module.exports = __webpack_public_path__ + "fonts/Sen-Regular.ac548074.woff";